module.exports = __webpack_public_path__ + "img/mob_home_03.177d9cb2.png";